<template>
  <div>
    <choose-payment :ispromo="true"></choose-payment>
    <h3>
      {{ staticContent.gifting.paymentMethod }}
    </h3>
    <div class="details-block">
      <div class="payment-option">
        <label class="custom-radio-holder">
          <input
            type="radio"
            name="payment"
            :value="promoForm.payment.paymentTypeEnum.CREDIT_CARD"
            :checked="promoForm.form.data.paymentTypeEnum == 'CREDIT_CARD'"
            @change="
              !creditCards || !creditCards.length
                ? openPaymentModal()
                : updatePromoPayment(
                    promoForm.payment.paymentTypeEnum.CREDIT_CARD,
                    null
                  )
            "
            class="visuallyhidden custom-radio-input"
          />
          <div class="custom-radio medium">
            <p class="input-label">
              <img
                v-if="
                  promoForm.payment.selectedCard ||
                  (creditCards && creditCards.length > 0)
                "
                :src="`/public/img/${
                  promoForm.payment.selectedCard
                    ? promoForm.payment.selectedCard.data.cardType
                    : creditCards[0].data.cardType
                }.png`"
                :class="
                  promoForm.payment.selectedCard
                    ? promoForm.payment.selectedCard.data.cardType
                    : creditCards[0].data.cardType
                "
                :alt="
                  promoForm.payment.selectedCard
                    ? promoForm.payment.selectedCard.data.cardType
                    : creditCards[0].data.cardType
                "
              />
              {{ staticContent.common.creditCard }}
              <span
                v-if="
                  promoForm.form.data.cardUUID ||
                  (creditCards && creditCards.length > 0)
                "
                >{{
                  promoForm.payment.selectedCard
                    ? promoForm.payment.selectedCard.data.number.substr(8, 8)
                    : creditCards[0].data.number.substr(8, 8)
                }}</span
              >
              <button type="button" @click="openPaymentModal">
                {{
                  creditCards && creditCards.length > 0
                    ? staticContent.common.change
                    : staticContent.common.addNew
                }}
              </button>
            </p>
          </div>
        </label>
      </div>
      <div class="payment-option" v-if="promoForm.openedForm == 'corporate'">
        <label class="custom-radio-holder">
          <input
            type="radio"
            name="payment"
            :value="promoForm.payment.paymentTypeEnum.CASH"
            :checked="promoForm.form.data.paymentTypeEnum == 'CASH_ON_DELIVERY'"
            @change="updatePromoPayment(promoForm.payment.paymentTypeEnum.CASH)"
            class="visuallyhidden custom-radio-input"
          />
          <div class="custom-radio medium">
            <p class="input-label">
              <img class="cash" src="/public/img/favicons/favicon-16x16.png" alt="cash" />
              {{ staticContent.gifting.cashPayement }}
            </p>
          </div>
        </label>
      </div>
    </div>
    <div>
      <h3>{{ staticContent.gifting.promoSummary }}</h3>
      <div class="details-block">
        <div class="row">
          <div class="col-xs-8">
            <label>{{ staticContent.gifting.promoValue }}</label>
          </div>
          <div class="col-xs-8 end-aligned">
            <label
              >
              <span class='mixed-lang'>{{ promoForm.form.data.phoneNumbers.length }} {{ staticContent.gifting.promo }} x <span class='remove-mixed-lang'>{{ promoForm.form.data.amount }}</span></span>
              <span class="currency">{{
                staticContent.gifting.currency
              }}</span></label
            >
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-xs-8">
            <label>{{ staticContent.gifting.total }}</label>
          </div>
          <div class="col-xs-8 end-aligned">
            <label>
              {{
                promoForm.form.data.phoneNumbers.length *
                promoForm.form.data.amount
              }}
              <span class="currency">{{ staticContent.gifting.currency }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="alert alert-danger" v-if="promoForm.form.errors">
        {{
          staticContent.checkout.placeOrderErrors[promoForm.form.errors]
            ? staticContent.checkout.placeOrderErrors[promoForm.form.errors]
            : staticContent.checkout.placeOrderErrors["GENERAL_FAIL"]
        }}
      </div>
      <button
        type="button"
        :disabled="
          promoForm.loading ||
          (promoForm.payment.method ==
            promoForm.payment.paymentTypeEnum.CREDIT_CARD &&
            !promoForm.form.data.cardUUID)
        "
        loading=""
        class="btn btn-primary"
        @click="createGifting"
      >
        <span v-if="promoForm.loading" class="loader white"> </span>
        {{ staticContent.gifting.sendPromos }}
      </button>
    </div>
  </div>
</template>

<script>
import {
  Vue,
  servicesURL,
  cookies,
  webClientID,
} from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("gifting-form-checkout", {
  data() {
    return {
      staticContent,
    };
  },
  mounted() {
    this.creditCards &&
      this.creditCards.length > 0 &&
      this.updatePromoPayment(
        this.promoForm.payment.paymentTypeEnum.CREDIT_CARD,
        this.creditCards[0].uuid
      );
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
    creditCards() {
      return this.$store.state.creditCards;
    },
    promoErrors() {
      return this.$store.getters.getCreatePromoErrors;
    },
    promoLoading() {
      return this.$store.getters.getCreatePromoLoading;
    },
    promoForm() {
      return this.$store.state.promoForm;
    },
    profileEmail() {
      return this.$store.state.profile.data.email;
    },
    profileName() {
      return (
        this.$store.state.profile.data.profile &&
        this.$store.state.profile.data.profile.name
      );
    },
  },
  methods: {
    createGifting() {
      let request = {
        giftPromoTypeEnum: this.promoForm.openedForm.toUpperCase(),
        ...this.promoForm.form.data,
      };
      !request.name && (request.name = this.profileName);
      !request.email && (request.email = this.profileEmail);
      this.$store.dispatch("PLACE_GIFTING_ORDER", request);
    },
    openPaymentModal() {
      this.profile && this.profile.data.profile
        ? this.$store.dispatch("PREP_ADD_CREDIT_CARD")
        : this.modalToggler("login-signup-modal", "show");
      this.modalToggler("payment-type-modal", "show");
    },
    modalToggler(modalId, action) {
      this.$root.modalToggler(modalId, action);
    },
    updatePromoPayment(method, carduuid = null) {
      this.$store.commit("updateGiftingPaymentMethod", method);
      carduuid && this.$store.commit("updateGiftingPaymentCard", carduuid);
    },
    handleGenericErrors(errorType) {
      this.$root.handleGenericErrors(errorType);
    },
  },
});
</script>
